import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { icQuestion } from "../../../components/image/image-src";
import { OkCancelPopup } from "../../../components/modal/OkCancelPopup";
import { TUsePopupHook, usePopup } from "../../../hooks/usePopup";
import ReceiveTicketModal from "../../MyPage/components/MyBooking/ReceiveTicketModal";

const ButtonReceiveTicket: React.FC<{
  booking: BookingState;
  bookNo?: string | number;
}> = ({ booking, bookNo }) => {
  const popup = usePopup();
  const navigate = useNavigate();
  const { t } = useTranslation();

  // const confirmAndRedirect = () => {
  //   popup.close();
  //   navigate("/ticket-check/booking-info/select-ticket");
  // };

  return (
    <div className="receive-ticket ml-auto">
      <button
        type="button"
        onClick={() => popup.open()}
        // className="font-noto-sans decoration-none w-[11.25rem] rounded-[3.125rem] border border-[#232323] bg-black py-[0.9375rem] text-center text-base font-semibold leading-5 text-white opacity-100 focus:ring-gray-200"
        className="ml-auto h-[2.5rem] w-[9.0625rem] rounded-[3.4375rem] bg-[#DBE7FF] text-[0.875rem] font-semibold leading-[1.375rem] text-primary-light"
      >
        {t("Receive Ticket")}
      </button>

      {popup.isOpen && !!bookNo && !!booking?.bookingDetailId && (
        <ReceiveTicketModal
          product={booking?.product}
          id={2}
          isOpen={popup.isOpen}
          // onSubmit={handleSubmitModal}
          onClose={popup.close}
          bookNo={bookNo}
          bookingDetailId={booking?.bookingDetailId!}
        />
      )}
    </div>
  );
};

export default ButtonReceiveTicket;

const TtPopupSuccess = ({ popup }: { popup: TUsePopupHook }) => {
  const { t } = useTranslation();
  return (
    <OkCancelPopup
      ic={icQuestion}
      title={t("Are you sure want to delete account?")}
      onOk={() => popup.onOk()}
      onCancel={undefined}
      okText={t("Delete")}
    />
  );
};
